import { formatDate } from 'date-fns'
import dayjs, { Dayjs } from 'dayjs'
import { Observable, observe, Scope } from 'wdc-cube'
import { ExportDocumentsScope } from 'src/components/exportdocuments/export_documents_scope'
import { UserRow } from '../admin/user-manager/um_scopes'
import { WaitingScope } from '../the-connection/tc_scopes'

export type HistoryQueryFilter = {
    startMonth: string
    endMonth?: string
    page: number
    limit: number
}

export type HistoryResponse<T> = HistoryQueryFilter & {
    totalRecords: number
    records: T[]
}
export type ExportHistoryRow = {
    seq?: number
    userId: number
    origem: string
    mesAno: Date
    dataHora: Date
    qtdRegistros: number
    groupId: number
    newLimitExport: number
    groupName: string
}

export type AggMesAnoHistoryRow = {
    mes_ano: string
    origem?: string
    qtd_registros: number
    group_id: number
    new_limit_export: number
    group_name: string
}

@Observable
export class HeaderScope extends Scope {}

@Observable
export class UserProfileScope extends Scope {
    readonly header = new HeaderScope()

    readonly exportDocsScope = new ExportDocumentsScope()

    @observe() profileScope = new ProfileScope()
    @observe() historyScope = new HistoryScope()
    @observe() chartScope = new ChartHistoryScope()
    @observe() filterScope = {
        filters: {
            startMonth: formatDate(Date.now(), 'yyyy-MM-dd'),
            page: 0,
            limit: 10
        },
        startMonth: dayjs(Date.now())
    } as ProfileFilterScope
    onOpenGroupProfile = Scope.ASYNC_ACTION_NUMBER
    onOpenChangePassword = Scope.ASYNC_ACTION
}

@Observable
export class ProfileFilterScope extends Scope {
    @observe() filters = {} as HistoryQueryFilter
    @observe() startMonth: Dayjs = dayjs(Date.now())
    @observe() endMonth?: Dayjs

    onFind = Scope.ASYNC_ACTION_ONE<Partial<HistoryQueryFilter>>()
}

@Observable
export class ProfileScope extends Scope {
    @observe() waiting?: WaitingScope
    @observe() profile = {} as UserRow
}

@Observable
export class HistoryScope extends Scope {
    @observe() history_working = false
    @observe() historyVersion = 0
    @observe() history = {} as HistoryResponse<ExportHistoryRow>

    onViewDocuments = Scope.ASYNC_ACTION_NUMBER
}

@Observable
export class ChartHistoryScope extends Scope {
    @observe() history_chart_working = false
    @observe() historyChart = {} as HistoryResponse<AggMesAnoHistoryRow>
}
